import { Styles } from "@mcleod/core";

export const SelectCheckboxTableCellStyles = Styles.make("tds", () => {
    return {
        base: {
            verticalAlign: "middle",
            paddingTop: "0px",
            paddingBottom: "0px",
            display: "table-cell",
            overflow: "hidden"
        }
    }
});
